export const SHOW_CONVERSATION = 'SHOW_CONVERSATION';
export const EMPTY_CONVERSATION = 'EMPTY_CONVERSATION';
export const SET_TICKET_STATUS_FOR_ALL_FILTER = 'SET_TICKET_STATUS_FOR_ALL_FILTER';
export const HYDRATE_ALL_TICKETS = 'HYDRATE_ALL_TICKETS';
export const START_ALL_TICKET_LQ = 'START_ALL_TICKET_LQ';
export const CLEAR_ALL_TICKET = 'CLEAR_ALL_TICKET';
export const HYDRATE_NOMINATED_TICKETS = 'HYDRATE_NOMINATED_TICKETS';
export const SET_BRAINTRUST_ENABLED = 'SET_BRAINTRUST_ENABLED';
export const HYDRATE_REVIEW_TICKETS = 'HYDRATE_REVIEW_TICKETS';
export const HYDRATE_ASSIGNED_TICKETS = 'HYDRATE_ASSIGNED_TICKETS';
export const HYDRATE_EXPERTS = 'HYDRATE_EXPERTS';
export const LOAD_CONVERSATION = 'LOAD_CONVERSATION';
export const CHANGE_TAB = 'CHANGE_TAB';
export const ALL_SEARCH_RESULTS = 'ALL_SEARCH_RESULTS';
export const ALL_SEARCH_ERROR = 'ALL_SEARCH_ERROR';
export const SELECT_TICKET_SEARCH_RESULT = 'SELECT_TICKET_SEARCH_RESULT';
export const CLEAR_SELECTED_TICKET_RESULT = 'CLEAR_SELECTED_TICKET_RESULT';
export const SET_DELETED_SEARCH_RESULT = 'SET_DELETED_SEARCH_RESULT';
export const CLEAR_DELETED_SEARCH_RESULT = 'CLEAR_DELETED_SEARCH_RESULT';
export const SET_RESULT_INDEX = 'SET_RESULT_INDEX';
export const SET_BTN_ACTIVITY = 'SET_BTN_ACTIVITY';
export const SET_TAG_ON_FORWARD_STATUS = 'SET_TAG_ON_FORWARD_STATUS';
export const HYDRATE_EXPERTS_FOR_FORWARDING_DROPDOWN = 'HYDRATE_EXPERTS_FOR_FORWARDING_DROPDOWN';
export const CLEAR_EXPERTS_FOR_FORWARDING_DROPDOWN = 'CLEAR_EXPERTS_FOR_FORWARDING_DROPDOWN';
export const SET_SEARCH_PARAM_FOR_FORWARDING_DROPDOWN = 'SET_SEARCH_PARAM_FOR_FORWARDING_DROPDOWN';
export const SET_SELECTED_EXPERT_FORWARDING_DROPDOWN = 'SET_SELECTED_EXPERT_FORWARDING_DROPDOWN';
export const UPDATE_ALL_TICKETS_TOTAL_COUNT = 'UPDATE_ALL_TICKETS_TOTAL_COUNT';
export const SET_SKIP_FOR_ALL_FILTER = 'SET_SKIP_FOR_ALL_FILTER';
export const RESET_NUM_CHAT_ACTIVE_ASSIGNED_FOR_EXPERT = 'RESET_NUM_CHAT_ACTIVE_ASSIGNED_FOR_EXPERT';
export const TOGGLE_NUDGE_POPUP = 'TOGGLE_NUDGE_POPUP';
export const SET_DEBUG_MODE = 'SET_DEBUG_MODE';
export const SET_PARTNER_PLATFORM_HISTORICAL_TICKETS = 'SET_PARTNER_PLATFORM_HISTORICAL_TICKETS';
export const UPDATE_PARTNER_PLATFORM_HISTORICAL_TICKET = 'UPDATE_PARTNER_PLATFORM_HISTORICAL_TICKET';
export const SELECT_INBOX_TAB = 'SELECT_INBOX_TAB';
export const UI_MESSAGES_SET_SHOW_TRANSLATED = 'UI_MESSAGES_SET_SHOW_TRANSLATED';
export const UPDATE_REVIEW_TICKET = 'UPDATE_REVIEW_TICKET';
export const REMOVE_REVIEW_TICKET = 'REMOVE_REVIEW_TICKET';
export const REMOVE_VALIDATION_TICKET = 'REMOVE_VALIDATION_TICKET';
export const SELECT_REVIEW_TICKET = 'SELECT_REVIEW_TICKET';
export const SELECT_NOMINATED_TICKET = 'SELECT_NOMINATED_TICKET';
export const SELECT_ASSIGNED_TICKET = 'SELECT_ASSIGNED_TICKET';
export const SELECT_LIVE_CHAT_TICKET = 'SELECT_LIVE_CHAT_TICKET';
export const SELECT_ALL_TICKET = 'SELECT_ALL_TICKET';
export const SELECT_HISTORICAL_TICKET = 'SELECT_HISTORICAL_TICKET';
export const CLEAR_SELECTED_TICKET = 'CLEAR_SELECTED_TICKET';
export const CLEAR_NOMINATED_TICKET = 'CLEAR_NOMINATED_TICKET';
export const CLEAR_ASSIGNED_TICKET = 'CLEAR_ASSIGNED_TICKET';
export const SELECT_VALIDATION_TICKET = 'SELECT_VALIDATION_TICKET';
export const REMOVE_TICKET = 'REMOVE_TICKET';
export const CLOSE_PREVIOUS_CONVERSATIONS_SECTION = 'CLOSE_PREVIOUS_CONVERSATIONS_SECTION';
export const OPEN_PREVIOUS_CONVERSATIONS_SECTION = 'OPEN_PREVIOUS_CONVERSATIONS_SECTION';
export const MOVE_TICKET = 'MOVE_TICKET';
export const MOVE_TICKET_FROM_ALL_TO_ASSIGNED = 'MOVE_TICKET_FROM_ALL_TO_ASSIGNED';
export const SET_TAGGING_ACTIVE = 'SET_TAGGING_ACTIVE';
export const UPDATE_LONG_TRANSACTION_LOADING_STATUS = 'UPDATE_LONG_TRANSACTION_LOADING_STATUS';
export const CLEAR_HISTORICAL_TICKET = 'CLEAR_HISTORICAL_TICKET';
export const SET_MOCK_PAGE_STATE = 'SET_MOCK_PAGE_STATE';
export const ADD_TICKET = 'ADD_TICKET';
export const UPDATE_TICKET_ORDER = 'UPDATE_TICKET_ORDER';
export const HYDRATE_HISTORICAL_TICKETS = 'HYDRATE_HISTORICAL_TICKETS';
export const TICKETS_SET_TO_EMPTY = 'TICKETS_SET_TO_EMPTY';
export const START_ONLOAD_LIVE_QUERY = 'START_ONLOAD_LIVE_QUERY';
export const START_ESCALATED_TICKET_LQ = 'START_ESCALATED_TICKET_LQ';
export const LIVE_QUERY_OFF = 'LIVE_QUERY_OFF';
export const LOAD_LONG_TRANSACTION = 'LOAD_LONG_TRANSACTION';
export const SAVE_NEW_MESSAGE_EDITOR_STATE = 'SAVE_NEW_MESSAGE_EDITOR_STATE';
export const SET_NEW_MESSAGE_COUPON_CODE_TYPE = 'SET_NEW_MESSAGE_COUPON_CODE_TYPE';
export const CLEAR_UNSENT_MESSAGE = 'CLEAR_UNSENT_MESSAGE';
export const SET_BLACKLIST = 'SET_BLACKLIST';
export const SET_CHAT_BLACKLIST = 'SET_CHAT_BLACKLIST';
export const TOGGLE_CHAT_ALERT_DISABLED = 'TOGGLE_CHAT_ALERT_DISABLED';
export const TOGGLE_NON_CHAT_ALERT_DISABLED = 'TOGGLE_NON_CHAT_ALERT_DISABLED';
export const SET_BUSINESS_CATEGORIES_AND_COMMUNICATION_TYPES = 'SET_BUSINESS_CATEGORIES_AND_COMMUNICATION_TYPES';
export const SET_BUSINESS_GREETING_QUESTION = 'SET_BUSINESS_GREETING_QUESTION';
export const SET_ESCALATION_MESSAGE = 'SET_ESCALATION_MESSAGE';
export const SET_CHAT_MACRO_RECOMMENDATIONS_ENABLED = 'SET_CHAT_MACRO_RECOMMENDATIONS_ENABLED';
export const SELECTED_TOOL = 'SELECTED_TOOL';

// coupon code action types
export const HYDRATE_COUPON_CODE_TYPES = 'HYDRATE_COUPON_CODE_TYPES';

export const ADD_MESSAGE = 'ADD_MESSAGE';
export const UPDATE_MESSAGE = 'UPDATE_MESSAGE';
export const SET_CONVERSATION_BLOCKED_WORDS_FOUND = 'SET_CONVERSATION_BLOCKED_WORDS_FOUND';
export const SET_CONVERSATION_OVERRIDABLE_WORDS_FOUND = 'SET_CONVERSATION_OVERRIDABLE_WORDS_FOUND';
export const UPDATE_OWN_AVAILABILITY = 'UPDATE_OWN_AVAILABILITY';
export const UPDATE_EXPERT = 'UPDATE_EXPERT';
export const UPDATE_AWAITING_WEB_CHAT_NOMINATION_COUNT = 'UPDATE_AWAITING_WEB_CHAT_NOMINATION_COUNT';
export const UPDATE_AWAITING_EMAIL_MESSAGE_NOMINATION_COUNT = 'UPDATE_AWAITING_EMAIL_MESSAGE_NOMINATION_COUNT';
export const SET_SIMPLR_TICKET_NUMBER_FOR_ALL_FILTER = 'SET_SIMPLR_TICKET_NUMBER_FOR_ALL_FILTER';
export const SET_WIDGET_ID_FOR_ALL_FILTER = 'SET_WIDGET_ID_FOR_ALL_FILTER';
export const SET_ROOM_ID_FOR_ALL_FILTER = 'SET_ROOM_ID_FOR_ALL_FILTER';
export const SET_PLATFORM_TICKET_ID_FOR_ALL_FILTER = 'SET_PLATFORM_TICKET_ID_FOR_ALL_FILTER';
export const CLEAR_ALL_FILTERS_EXCEPT_SIMPLR_TICKET_NUMBER = 'CLEAR_ALL_FILTERS_EXCEPT_SIMPLR_TICKET_NUMBER';
export const SET_ALL_TAB_SEARCH_PERFORMED = 'SET_ALL_TAB_SEARCH_PERFORMED';
export const UPDATE_TICKET = 'UPDATE_TICKET';
export const ADD_PREVIOUS_TICKETS = 'ADD_PREVIOUS_TICKETS';
export const SET_PARTNER_TAGS = 'SET_PARTNER_TAGS';
export const CLEAR_PARTNER_TAGS = 'CLEAR_PARTNER_TAGS';
export const SET_QUERY_FOR_LDA = 'SET_QUERY_FOR_LDA';
export const SET_SELECTED_BUSINESS_INFO = 'SET_SELECTED_BUSINESS_INFO';
export const ON_PASTE_TEXT = 'ON_PASTE_TEXT';
export const SET_CLIPBOARD_TEXT = 'SET_CLIPBOARD_TEXT';

// businesses actions
export const HYDRATE_BUSINESSES = 'HYDRATE_BUSINESSES';
export const SET_BUSINESS_ACCOUNT_STATUS = 'SET_BUSINESS_ACCOUNT_STATUS';
export const SET_SELECTED_BUSINESSES_FOR_ALL_FILTER = 'SET_SELECTED_BUSINESSES_FOR_ALL_FILTER';
export const SET_SELECTED_BUSINESS_BRAND_OPTIONS_FOR_ALL_FILTER = 'SET_SELECTED_BUSINESS_BRAND_OPTIONS_FOR_ALL_FILTER';
export const SET_BUSINESSES_BRAND_OPTIONS_FOR_ALL_FILTER = 'SET_BUSINESSES_BRAND_OPTIONS_FOR_ALL_FILTER';
export const SET_EXCLUDE_BUSINESSES_FOR_ALL_FILTER = 'SET_EXCLUDE_BUSINESSES_FOR_ALL_FILTER';
export const SET_DATE_RANGE_FOR_ALL_FILTER = 'SET_DATE_RANGE_FOR_ALL_FILTER';
export const SET_MINIMUM_EXPERT_RANK = 'SET_MINIMUM_EXPERT_RANK';
export const SET_EXPERT_RANKS = 'SET_EXPERT_RANKS';
export const SET_EXTRA_BUSINESS_INFO = 'SET_EXTRA_BUSINESS_INFO';
export const SET_BUSINESS_SIMPLR_CATEGORIES = 'SET_BUSINESS_CATEGORIES';
export const SET_PARTNER_INFO = 'SET_PARTNER_INFO';
export const SET_TAGS_CONFIG = 'SET_TAGS_CONFIG';
export const SET_BRAND_OPTIONS = 'SET_BRAND_OPTIONS';
export const SET_DECISION_TREE = 'SET_DECISION_TREE';
export const SET_DECISION_TREE_DRAFTS = 'SET_DECISION_TREE_DRAFTS';
export const SET_USE_MENU_OPERATOR = 'SET_USE_MENU_OPERATOR';
export const SET_SUBBUSINESS_VERTICALS = 'SET_SUBBUSINESS_VERTICALS';
export const UPDATE_BUSINESS_SPAM_FILTER = 'UPDATE_BUSINESS_SPAM_FILTER';
export const UPDATE_BUSINESS_TAGS_MAP = 'UPDATE_BUSINESS_TAGS_MAP';
export const HYDRATE_BUSINESSES_DETAILS_PAGE = 'HYDRATE_BUSINESSES_DETAILS_PAGE';
export const HYDRATE_BUSINESSES_DETAILS_LIST = 'HYDRATE_BUSINESSES_DETAILS_LIST';
export const SET_SEARCH_PARAMS_BUSINESSES_DETAILS = 'SET_SEARCH_PARAMS_BUSINESSES_DETAILS';
export const SET_FLOW_DEBUG_STATE_FAVORITE_FIELDS_LIST = 'SET_FLOW_DEBUG_STATE_FAVORITE_FIELDS_LIST';

// macro wizard and decision tree paths
export const SET_DECISION_TREE_PATH = 'SET_DECISION_TREE_PATH';
export const SET_MACROS_BY_TAG_PATH = 'SET_MACROS_BY_TAG_PATH';
export const SET_DECISION_FLOWS_DATA = 'SET_DECISION_FLOWS_DATA';
export const CLEAR_SEARCH = 'CLEAR_SEARCH';
export const RESTART_DECISION_FLOW_REQUESTED = 'RESTART_DECISION_FLOW_REQUESTED';

// search analytics actions
export const SET_SEARCH_ID = 'SET_SEARCH_ID';

export const ADD_UNREAD_NOMINATED_TICKET_ID = 'ADD_UNREAD_NOMINATED_TICKET_ID';
export const SET_AB_TEST_CONFIG = 'SET_AB_TEST_CONFIG';

export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
export const CLEAR_ALL_TAB_NOTIFICATIONS = 'CLEAR_ALL_TAB_NOTIFICATIONS';
export const ADD_TAB_NOTIFICATION_TO_QUEUE = 'ADD_TAB_NOTIFICATION_TO_QUEUE';
export const CLEAR_TAB_NOTIFICATIONS_FOR_TICKET = 'CLEAR_TAB_NOTIFICATIONS_FOR_TICKET';
export const ROTATE_NOTIFICATIONS_IF_MULTIPLE = 'ROTATE_NOTIFICATIONS_IF_MULTIPLE';

// Escalated tab filters
export const SET_SELECTED_BUSINESSES_FOR_ESCALATED_FILTER = 'SET_SELECTED_BUSINESSES_FOR_ESCALATED_FILTER';
export const SET_EXCLUDE_BUSINESSES_FOR_ESCALATED_FILTER = 'SET_EXCLUDE_BUSINESSES_FOR_ESCALATED_FILTER';
export const SET_COMMUNICATION_TYPE_FOR_ESCALATED_FILTER = 'SET_COMMUNICATION_TYPE_FOR_ESCALATED_FILTER';
export const CLEAR_ESCALATED_FILTERS = 'CLEAR_ESCALATED_FILTERS';

export const SET_OUTBOUND_ESCALATION_MESSAGE = 'SET_OUTBOUND_ESCALATION_MESSAGE';
export const LOCK_CONVERSATION = 'LOCK_CONVERSATION';
export const UNLOCK_CONVERSATION = 'UNLOCK_CONVERSATION';
export const SET_LOADING_MESSAGE = 'SET_LOADING_MESSAGE';
export const SET_LOADING = 'SET_LOADING';
export const SET_LOADING_UNIQUE = 'SET_LOADING_UNIQUE';

// ML services data
export const SET_ML_ORDERS_IDS = 'SET_ML_ORDERS_IDS';
export const SET_CENTER_PANE_EXTRA_INFO_PANEL_ACTIVE = 'SET_CENTER_PANE_EXTRA_INFO_PANEL_ACTIVE';
export const SET_ESC_RECO_SEEN = 'SET_ESC_RECO_SEEN';
export const SET_RECOMMENDED_PRODUCTS_FOR_PARTNER = 'SET_RECOMMENDED_PRODUCTS_FOR_PARTNER';
export const SET_RECOMMENDATION_AS_PREVIOUSLY_TRIGGERED = 'SET_RECOMMENDATION_AS_PREVIOUSLY_TRIGGERED';
export const SET_ACTIVE_ESC_RECO_POPUP_ID = 'SET_ACTIVE_ESC_RECO_POPUP_ID';
export const SET_EASY_CONNECTION_DATA = 'SET_EASY_CONNECTION_DATA';
export const SET_AGENT_ASSIST_MACRO_RECOMMENDATION = 'SET_AGENT_ASSIST_MACRO_RECOMMENDATION';

export const SET_PARSE_CONFIGS = 'SET_PARSE_CONFIGS';

export const LOCK_SENSITIVE_DATA = 'LOCK_SENSITIVE_DATA';
export const UNLOCK_SENSITIVE_DATA = 'UNLOCK_SENSITIVE_DATA';

export const UPDATE_BUSINESS_ALERT = 'UPDATE_BUSINESS_ALERT';
export const DELETE_BUSINESS_ALERT = 'DELETE_BUSINESS_ALERT';
export const SET_ALERT_MANAGER_TYPE = 'SET_ALERT_MANAGER_TYPE';
export const SET_BLOCKING_ALERT_VIEWED = 'SET_BLOCKING_ALERT_VIEWED';
export const CLEAR_BLOCKING_ALERT_VIEWED_IDS = 'CLEAR_BLOCKING_ALERT_VIEWED_IDS';
export const SET_LOADING_FOR_MACRO_WIZARD = 'SET_LOADING_FOR_MACRO_WIZARD';
export const SET_PATH_WAS_RESET = 'SET_PATH_WAS_RESET';

export const SET_PREVIOUS_APP_VERSION_FILE = 'SET_PREVIOUS_VERSION_FILE';
export const SET_SHOW_APP_VERSION_REFRESH_NOTIFICATION = 'SET_SHOW_APP_VERSION_REFRESH_NOTIFICATION';
export const SHOW_TOOLS = 'SHOW_TOOLS';
export const TOOLS_LOADING = 'TOOLS_LOADING';
export const SET_SHOW_SPECIALIST_TOOLS = 'SET_SHOW_SPECIALIST_TOOLS';
export const SET_EXPERT_DASHBOARD_OPENED = 'SET_EXPERT_DASHBOARD_OPENED';

// display
export const SET_TICKET_REMOVAL_IN_PROCESS = 'SET_TICKET_REMOVAL_IN_PROCESS';

// commerce wizard
export const SET_COMMERCE_WIZARD_PATH = 'SET_COMMERCE_WIZARD_PATH';
export const SET_COMMERCE_WIZARD_SELECTED_RECOMMENDATION = 'SET_COMMERCE_WIZARD_SELECTED_RECOMMENDATION';
export const SET_COMMERCE_WIZARD_PREVIOUS_RECOMMENDATION = 'SET_COMMERCE_WIZARD_PREVIOUS_RECOMMENDATION';

export const SET_CHAT_ALERT_ACTIVE_ID = 'SET_CHAT_ALERT_ACTIVE_ID';

// conversation ratings
export const SET_CONVERSATION_RATING_SCORE = 'SET_CONVERSATION_RATING_SCORE';
export const SET_CONVERSATION_RATING_SCORE_DATA = 'SET_CONVERSATION_RATING_SCORE_DATA';
export const DELETE_CONVERSATION_RATING = 'DELETE_CONVERSATION_RATING';

// inProgressTreeAndWizardLocation
export const SET_IN_PROGRESS_TREE_AND_WIZARD_LOCATION = 'SET_IN_PROGRESS_TREE_AND_WIZARD_LOCATION';
export const CLEAR_IN_PROGRESS_TREE_AND_WIZARD_LOCATION = 'CLEAR_IN_PROGRESS_TREE_AND_WIZARD_LOCATION';

// ChatUI
export const SET_CHAT_UI_STATUS = 'SET_CHAT_UI_STATUS';
export const SET_CHAT_PRODUCT_REC_MACRO_COPIED = 'SET_CHAT_PRODUCT_REC_MACRO_COPIED';

// rbi gift card
export const SET_RBI_CUSTOMER_INFO = 'SET_RBI_CUSTOMER_INFO';
export const SET_RBI_GIFT_CARD_TRANSFER = 'SET_RBI_GIFT_CARD_TRANSFER';
export const CLEAR_TOOLS_RBI_STORE = 'CLEAR_TOOLS_RBI_STORE';

// decision trees
export const SET_DECISION_TREES = 'SET_DECISION_TREES';
export const CLEAR_TOOLS_RBI_CUSTOMER_STORE = 'CLEAR_TOOLS_RBI_CUSTOMER_STORE';

// conversation attachment section
export const CLOSE_ATTACHMENTS_SECTION = 'CLOSE_ATTACHMENTS_SECTION';
export const OPEN_ATTACHMENTS_SECTION = 'OPEN_ATTACHMENTS_SECTION';

// MFA
export const SET_MFA_INFORMATION = 'SET_MFA_INFORMATION';

// login
export const UPDATE_USER = 'UPDATE_USER';
export const CHANGE_LOGIN_STATUS = 'CHANGE_LOGIN_STATUS';
export const CHANGE_SESSION_VALID_STATUS = 'CHANGE_SESSION_VALID_STATUS';
export const UPDATE_AVAILABILITY_SWITCH_LOCK_EXP = 'UPDATE_AVAILABILITY_SWITCH_LOCK_EXP';
export const UPDATE_EXPERT_TOGGLE_LOCK_CONFIRMATION = 'UPDATE_EXPERT_TOGGLE_LOCK_CONFIRMATION';

export const SET_PAGINATION_FOR_ALL_FILTER = 'SET_PAGINATION_FOR_ALL_FILTER';
export const RESET_PAGINATION_FOR_ALL_FILTER = 'RESET_PAGINATION_FOR_ALL_FILTER';

// NOTE(vlad|SPD-14347|2026-03-03): Consolidated all-tab filter actions
export const SET_ALL_FILTERS = 'SET_ALL_FILTERS';
export const UPDATE_FILTER = 'UPDATE_FILTER';
export const CLEAR_ALL_FILTERS = 'CLEAR_ALL_FILTERS';
export const APPLY_SORT_ORDER = 'APPLY_SORT_ORDER';

// tools
export const SET_INTEGRATION_OPTIONS = 'SET_INTEGRATION_OPTIONS';

// auth
export const DO_PRE_LOGIN = 'DO_PRE_LOGIN';
export const DO_PRE_LOGOUT = 'DO_PRE_LOGOUT';
export const AUTH_ERROR = 'AUTH_ERROR';
export const CLEAR_AUTH_ERROR = 'CLEAR_AUTH_ERROR';
